import * as angular from "angular";
import {IRootScopeService, ITimeoutService, IWindowService} from "angular";

export class BarcodeScannerService {


  chars: any = [];
  pressed: boolean = false;
  barcodeMinimumLength: number = 8;

  constructor(private $rootScope: IRootScopeService, private $window: IWindowService, private $timeout: ITimeoutService) {
  }

  startListening() {
    angular.element(this.$window).on('keydown', (event) => {
      // if a number is pressed we add it to the chars array
      if (event.which >= 48 && event.which <= 122) {
        this.chars.push(String.fromCharCode(event.which));
      }

      // entering only once
      if (this.pressed === false) {
        this.$timeout(() => {
          // barcode minimum length
          if (this.chars.length >= this.barcodeMinimumLength) {
            // join the chars array to make a string of the barcode scanned
            let barcode = this.chars.join("");
            this.$rootScope.$broadcast('barcode-scanned', barcode);
          }
          this.chars = [];
          this.pressed = false;
        }, 400);

      }
      this.pressed = true;
    });
  }

  stopListening() {
    angular.element(this.$window).off('keydown');
  }
}

angular
  .module('bringoz.admin.commons')
  .service('barcodeScannerService', BarcodeScannerService);
